import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const CancelIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue5c9'}</MuiIcon>
        );
    })
